import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authMe, getUser, clearToken, isAuthed } from "../lib/api";
import { routeForUser } from "./Login";
import "../studio.css";

export default function Pending() {
  const nav = useNavigate();
  const [user, setUserState] = useState(getUser());

  useEffect(() => {
    if (!isAuthed()) { nav("/login"); return; }
    const check = async () => {
      try {
        const u = await authMe();
        setUserState(u);
        if (u && (u.companyStatus === "approved" || u.role === "platform_admin")) {
          nav(routeForUser(u));
        }
      } catch (e) { console.debug("pending: still awaiting approval", e); /* keep waiting */ }
    };
    check();
    const id = setInterval(check, 15000);
    return () => clearInterval(id);
  }, [nav]);

  const rejected = user?.companyStatus === "rejected";

  return (
    <div className="cts-scope">
      <div className="login-wrap">
        <div className="login-card" data-testid="pending-card">
          <div className="brand"><div className="glyph" /><div className="name">Studio <span>/ CloudTV</span></div></div>
          {rejected ? (
            <>
              <h1>Access not approved</h1>
              <p>Your company <b>{user?.companyName}</b> was not approved for access. If you think this is a mistake, reach out to your CloudTV contact.</p>
            </>
          ) : (
            <>
              <h1>You're on the waiting list</h1>
              <p>Thanks for signing up, <b>{user?.name || user?.email}</b>. Your company <b>{user?.companyName}</b> is pending review.</p>
              <div className="callout-soft" data-testid="pending-status">
                <span className="pulse-dot" /> Awaiting approval — we'll email you at <b>{user?.email}</b> the moment you're in.
              </div>
              <p className="hint-inline">This page checks automatically. You can close it and come back after you get the email.</p>
            </>
          )}
          <button className="btn block" onClick={() => { clearToken(); nav("/login"); }} data-testid="pending-signout">Sign out</button>
        </div>
      </div>
    </div>
  );
}
